export default "/images/a4475a4fcdaae7de20cd313ee541d4b6.avif";